export default {
  ResultItemTitle: 'Result Item',
  resultItemId: 'รหัสรายการตรวจ',
  resultItemDesc: 'ชื่อรายการตรวจ',
  nickname: 'ชื่อเล่น',
  uom: 'หน่วยนับสินค้า',
  buttonNewResultItem: 'สร้างรายการตวจใหม่',
  buttonDeleteResultItem: 'ลบรายการตวจ',
  newResultItem: 'สร้างรายการตรวจใหม่',
  idMissing: 'กรุณาระบุรหัสรายการตรวจ',
  descMissing: 'กรุณาระบุชื่อรายการตรวจ',
  nicknameMissing: 'กรุณาระบุชื่อย่อ',
  uomMissing: 'กรุณาระบุหน่วยนับสินค้า',
  confirmDeleteSelected: 'คุณต้องการที่จะลบรายการสั่งตรวจที่เลือก?',
  messageDeleteNotSelected: 'กรุณาเลือกรายการสั่งตรวจที่จะลบ',
  editHeader: 'แก้ไขรายการสั่งตรวจ',
  addHeader: 'เพิ่มรายการสั่งตรวจ'
}
